export enum AppEnvironments {
  dev = "dev",
  production = "production",
  staging = "staging",
}

export class Environment {
  static get currentEnvironment(): AppEnvironments {
    let currentEnv = window.location.host.toLowerCase();
    if (currentEnv === "business.buypass.ai") {
      return AppEnvironments.production;
    } else if (currentEnv === "sellerbuypass.neksoft.com") {
      return AppEnvironments.dev;
    } else if (currentEnv === "uat-business.buypass.ai") {
      return AppEnvironments.staging;
    }
    return AppEnvironments.staging;
  }
  
  static get apiUrl(): string {
    switch (this.currentEnvironment) {
      case AppEnvironments.production:
        return "https://api.buypass.ai/vendor";
      case AppEnvironments.staging:
        return "https://api-uat.buypass.ai/vendor";
      case AppEnvironments.dev:
        return "https://apibuypass.neksoft.com/vendor";
      default:
        return "https://apibuypass.neksoft.com/vendor";
    }
  }
  static get socketUrl(): string {
    switch (this.currentEnvironment) {
      case AppEnvironments.production:
        return "wss://websocket.buypass.ai/websocket";
      case AppEnvironments.staging:
        return "wss://uat-websocket.buypass.ai";
      case AppEnvironments.dev:
        return "wss://websocket.buypass.ai/websocket";
      default:
        return "wss://websocket.buypass.ai/websocket";
    }
  }
  static get EnvrionmentUrl(): string {
    switch (this.currentEnvironment) {
      case AppEnvironments.production:
        return "https://api.buypass.ai";
      case AppEnvironments.staging:
        return "https://api-uat.buypass.ai";
      case AppEnvironments.dev:
        return "https://apibuypass.neksoft.com";
      default:
        return "https://apibuypass.neksoft.com";
    }
  }
  static get firebaseConfig() {
    switch (this.currentEnvironment) {
      case AppEnvironments.production:
        return {
          apiKey: "AIzaSyDafC1byn8vv4SUe9t930UwcfdLKPhZfDw",
          authDomain: "buypass-ai.firebaseapp.com",
          databaseURL: "https://buypass-ai-default-rtdb.firebaseio.com",
          projectId: "buypass-ai",
          storageBucket: "buypass-ai.firebasestorage.app",
          messagingSenderId: "666627398711",
          appId: "1:666627398711:web:87df65af9a2e0abb7873b2",
          measurementId: "G-2EE00X7F32",
        };
      case AppEnvironments.staging:
        return {
          apiKey: "AIzaSyBwH4Mu4NzrpasJVjEAoVyGi4Dn-GmLAmU",
          authDomain: "buypass-staging.firebaseapp.com",
          databaseURL: "https://buypass-staging-default-rtdb.firebaseio.com",
          projectId: "buypass-staging",
          storageBucket: "buypass-staging.firebasestorage.app",
          messagingSenderId: "679904068567",
          appId: "1:679904068567:web:b95e482076d0b8da8d4192",
          measurementId: "G-F87Z8V4Y64",
        };
      case AppEnvironments.dev:
        return {
          apiKey: "AIzaSyApFOhcj7WrZOnplTaJuonywfiwFDrN5So",
          authDomain: "market-place-299a6.firebaseapp.com",
          databaseURL: "https://market-place-299a6-default-rtdb.firebaseio.com",
          projectId: "market-place-299a6",
          storageBucket: "market-place-299a6.appspot.com",
          messagingSenderId: "572052099635",
          appId: "1:572052099635:web:a3ba831cc7313345114946",
          measurementId: "G-B5VCBVTRY8",
        };
      default:
        return {
          apiKey: "AIzaSyApFOhcj7WrZOnplTaJuonywfiwFDrN5So",
          authDomain: "market-place-299a6.firebaseapp.com",
          databaseURL: "https://market-place-299a6-default-rtdb.firebaseio.com",
          projectId: "market-place-299a6",
          storageBucket: "market-place-299a6.appspot.com",
          messagingSenderId: "572052099635",
          appId: "1:572052099635:web:a3ba831cc7313345114946",
          measurementId: "G-B5VCBVTRY8",
        };
    }
  }
}
